import { Component, inject, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { DOCUMENT } from '@angular/common';
import * as Sentry from "@sentry/angular";
import { take } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
  standalone: false,
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    public oidcSecurityService: OidcSecurityService,
  ) {
  }

  private readonly document: Document = inject(DOCUMENT);

  ngOnInit(): void {
    this.checkAuth();
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    this.oidcSecurityService.logoff();
  }

  checkAuth() {
    const redirectUrl = this.document?.defaultView?.location.toString() ?? undefined;
    this.oidcSecurityService.checkAuth(redirectUrl).subscribe({
      next: (loginResponse) => {
        console.log('EFS Login');
        console.log('Config-ID: ', loginResponse.configId);
        console.log('Error Message: ', loginResponse.errorMessage);
        console.log('IsAuthenticated: ', loginResponse.isAuthenticated);

        if (!loginResponse.isAuthenticated) {
          sessionStorage.clear();
          this.oidcSecurityService.logoffAndRevokeTokens();
          this.oidcSecurityService.authorize();
        }

        if (loginResponse.userData) {
          Sentry.setUser({
            username: loginResponse.userData.preferred_username,
          })
        }
      },
      error: (error) => {
        sessionStorage.clear();
        this.oidcSecurityService.logoffAndRevokeTokens();
        this.oidcSecurityService.authorize();
      }
    });
  }
}
